import { axiosInstance } from '../utils/axiosinstance';

// Types for category data
export interface Category {
  _id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface CategoriesResponse {
  success: boolean;
  message?: string;
  data: Category[];
}

export interface SingleCategoryResponse {
  success: boolean;
  message?: string;
  data: {
    category: Category;
  };
}

export interface CreateCategoryRequest {
  name: string;
}

export interface UpdateCategoryRequest {
  name?: string;
}

// Category API functions
export const categoryApi = {
  // Get all categories
  getCategories: async (): Promise<CategoriesResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.get('/api/v1/categories', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data;
  },

  // Get single category details
  getCategoryById: async (id: string): Promise<SingleCategoryResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.get(`/api/v1/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data;
  },

  // Create new category
  createCategory: async (categoryData: CreateCategoryRequest): Promise<SingleCategoryResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.post('/api/v1/categories', categoryData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  },

  // Update category details
  updateCategory: async (id: string, updateData: UpdateCategoryRequest): Promise<SingleCategoryResponse> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.put(`/api/v1/categories/${id}`, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  },

  // Delete a category
  deleteCategory: async (id: string): Promise<{ success: boolean; message?: string }> => {
    const token = localStorage.getItem('adminToken');
    
    const response = await axiosInstance.delete(`/api/v1/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    return response.data;
  },
};
